import { http } from "../http";

export const getEmployment = async (userId) => {
  try {
    const response = await http.get(`/api/employment?user_id=${userId}`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getEmploymentTypes = async () => {
  try {
    const response = await http.get(`/api/Employment_Types`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOcafFacilities = async (agencyId) => {
  try {
    const response = await http.get(`/api/Ocaf_Facilities`, {
      params: agencyId ? { agency_id: agencyId } : {},
    });
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getEmploymentJobTitles = async () => {
  try {
    const response = await http.get(`/api/Employment_Job_Titles`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getCounties = async () => {
  try {
    const response = await http.get(`/api/Counties`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getColleges = async () => {
  try {
    const response = await http.get(`/api/Colleges`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getSubPools = async () => {
  try {
    const response = await http.get(`/api/SubPools`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const searchPrograms = async (searchParams) => {
  try {
    const response = await http.get(`/api/programs/search`, {
      params: searchParams,
    });
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getAgeGroups = async () => {
  try {
    const response = await http.get(`/api/Age_Groups`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const updatePrimary = async (employmentId, userId) => {
  try {
    const response = await http.post(`api/employment/set_primary`, {
      id: employmentId,
      user_id: userId,
    });
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getSurveyData = async (id, oin) => {
  try {
    let baseUrl = `/api/Exitsurvey/${id}`;
    if (oin) {
      baseUrl += `?oin=${oin}`;
    }
    const response = await http.get(baseUrl);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

// NOTE: payload must contain an oin element identifying the current org id
export const submitSurvey = async (id, payload) => {
  try {
    let baseUrl = `/api/Exitsurvey/${id}`;
    const response = await http.post(baseUrl, payload);
    console.log({ response });
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};
